import { Check, Clock, ArrowDownLeft, CircleDashed, BadgeCheck } from "lucide-react";
import { statusOf } from "@/lib/sheet-utils";
import { useCanEdit } from "@/lib/app-context";

const STYLES = {
  paid: ["Paid", Check, "bg-emerald-100 text-emerald-800 border-emerald-300"],
  settled: ["Settled", BadgeCheck, "bg-teal-100 text-teal-800 border-teal-300"],
  part: ["Part paid", CircleDashed, "bg-sky-100 text-sky-800 border-sky-300"],
  pending: ["Pending", Clock, "bg-amber-100 text-amber-800 border-amber-300"],
  receivable: ["Receivable", ArrowDownLeft, "bg-red-100 text-red-700 border-red-300"],
};

export function PaidToggle({ row, onToggle, testId }) {
  const [label, Icon, cls] = STYLES[statusOf(row)];
  const canEdit = useCanEdit();
  return (
    <button
      type="button"
      onClick={canEdit ? onToggle : undefined}
      disabled={!canEdit}
      title={!canEdit ? label : row.paid ? "Tap to mark unpaid" : "Tap to mark fully paid"}
      data-testid={testId}
      className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-bold border whitespace-nowrap transition-transform active:scale-95 ${cls}`}
    >
      <Icon size={12} />{label}
    </button>
  );
}
